import type { TDataExportValueTypesTimeseriesGroup } from 'App/data-export/types/from-code-gen/TDataExportValueTypesTimeseriesGroup'
import { translate } from 'i18n/i18n'
import { getInsectNameFromId } from 'utils/getInsectNameFromId'

const insectDegreeDaysLabelMaker = (insectId: number) => () =>
  translate.phrases.banyanApp('{{insectName}} Degree Days', { insectName: getInsectNameFromId(insectId) })

const insectTrapCatchesLabelMaker = (insectId: number) => () =>
  translate.phrases.banyanApp('{{insectName}} Trap Catches', { insectName: getInsectNameFromId(insectId) })

export const mapValueGroupToLabel: Record<TDataExportValueTypesTimeseriesGroup, () => string> = {
  almond_bloom: () => translate.phrases.banyanApp('Almond Bloom'),
  air_temperature: () => translate.phrases.banyanApp('Temperature'),
  alternaria: () => translate.phrases.banyanApp('Alternaria'),
  bee_hours: () => translate.phrases.banyanApp('Bee Hours'),
  chill: () => translate.phrases.banyanApp('Chill'),
  degree_days_insect_id_1: insectDegreeDaysLabelMaker(1),
  degree_days_insect_id_2: insectDegreeDaysLabelMaker(2),
  degree_days_insect_id_3: insectDegreeDaysLabelMaker(3),
  degree_days_insect_id_4: insectDegreeDaysLabelMaker(4),
  degree_days_insect_id_6: insectDegreeDaysLabelMaker(6),
  degree_days_insect_id_7: insectDegreeDaysLabelMaker(7),
  degree_days_insect_id_8: insectDegreeDaysLabelMaker(8),
  degree_days_insect_id_9: insectDegreeDaysLabelMaker(9),
  degree_days_insect_id_10: insectDegreeDaysLabelMaker(10),
  degree_days_insect_id_11: insectDegreeDaysLabelMaker(11),
  degree_days_insect_id_12: insectDegreeDaysLabelMaker(12),
  degree_days_insect_id_13: insectDegreeDaysLabelMaker(13),
  degree_days_insect_id_14: insectDegreeDaysLabelMaker(14),
  degree_days_insect_id_15: insectDegreeDaysLabelMaker(15),
  degree_days_insect_id_16: insectDegreeDaysLabelMaker(16),
  degree_days_insect_id_17: insectDegreeDaysLabelMaker(17),
  degree_days_insect_id_18: insectDegreeDaysLabelMaker(18),
  degree_days_insect_id_19: insectDegreeDaysLabelMaker(19),
  degree_days_insect_id_20: insectDegreeDaysLabelMaker(20),
  degree_days_insect_id_23: insectDegreeDaysLabelMaker(23),
  degree_days_insect_id_24: insectDegreeDaysLabelMaker(24),
  degree_days_insect_id_25: insectDegreeDaysLabelMaker(25),
  degree_days_insect_id_26: insectDegreeDaysLabelMaker(26),
  degree_days_insect_id_27: insectDegreeDaysLabelMaker(27),
  degree_days_insect_id_28: insectDegreeDaysLabelMaker(28),
  degree_days_insect_id_29: insectDegreeDaysLabelMaker(29),
  degree_days_insect_id_30: insectDegreeDaysLabelMaker(30),
  dew_point: () => translate.phrases.banyanApp('Dew Point'),
  evapotranspiration: () => translate.phrases.banyanApp('Evapotranspiration'),
  fire_blight: () => translate.phrases.banyanApp('Fire Blight'),
  fruit_growth: () => translate.phrases.banyanApp('Fruit Growth'),
  humidity: () => translate.phrases.banyanApp('Humidity'),
  irrigation: () => translate.phrases.banyanApp('Irrigation'),
  leaf_wetness: () => translate.phrases.banyanApp('Leaf Wetness'),
  plant_stress: () => translate.phrases.banyanApp('Plant Stress'),
  precipitation: () => translate.phrases.banyanApp('Rain'),
  soil: () => translate.phrases.banyanApp('Soil'),
  trap_catches_insect_id_1: insectTrapCatchesLabelMaker(1),
  trap_catches_insect_id_2: insectTrapCatchesLabelMaker(2),
  trap_catches_insect_id_6: insectTrapCatchesLabelMaker(6),
  trap_catches_insect_id_7: insectTrapCatchesLabelMaker(7),
  trap_catches_insect_id_9: insectTrapCatchesLabelMaker(9),
  trap_catches_insect_id_10: insectTrapCatchesLabelMaker(10),
  trap_catches_insect_id_11: insectTrapCatchesLabelMaker(11),
  trap_catches_insect_id_12: insectTrapCatchesLabelMaker(12),
  trap_catches_insect_id_15: insectTrapCatchesLabelMaker(15),
  trap_catches_insect_id_16: insectTrapCatchesLabelMaker(16),
  trap_catches_insect_id_17: insectTrapCatchesLabelMaker(17),
  trap_catches_insect_id_19: insectTrapCatchesLabelMaker(19),
  trap_catches_insect_id_20: insectTrapCatchesLabelMaker(20),
  trap_catches_insect_id_25: insectTrapCatchesLabelMaker(25),
  trap_catches_insect_id_27: insectTrapCatchesLabelMaker(27),
  trap_catches_insect_id_28: insectTrapCatchesLabelMaker(28),
  trap_catches_insect_id_29: insectTrapCatchesLabelMaker(29),
  trap_catches_insect_id_30: insectTrapCatchesLabelMaker(30),
  wet_bulb: () => translate.phrases.banyanApp('Wet Bulb'),
  wind: () => translate.phrases.banyanApp('Wind'),
}
